
import React, { useState } from "react";
import { InputGroup, Form, Button } from "react-bootstrap";
import { useCopyToClipboard, Message, MessageHandlerDisplayType, MessageToastTypes, useAppDispatch } from "src/common";
import { Icon } from "src/components";
import { uiActions } from "src/store";

type AllProps = {
  password: string;
}

function MailClientPasswordComponent(props: AllProps) {
  const { password } = props;
  const [show_password, setShowPassword] = useState<boolean>(false);
  const { copy } = useCopyToClipboard();
  const dispatch = useAppDispatch();

  function handleCopyPassword(password_copy: string) {
    copy(password_copy);
    dispatch(uiActions.handleSetMessage(new Message("Copied", MessageHandlerDisplayType.toastr, MessageToastTypes.light)));
  }

  return <InputGroup>
    <Form.Control
      type={show_password ? "text" : "password"}
      value={password}
      readOnly
    />
    <Button
      variant="transparent"
      className="btn-icon"
      size="sm"
      onClick={() => setShowPassword(!show_password)}
      aria-label="show password">
      <span>
        <Icon className={!!show_password ? "ficon-eye" : "ficon-eye-off"} />
      </span>
    </Button>
    <Button
      variant="transparent"
      className="btn-icon"
      size="sm"
      onClick={() => handleCopyPassword(password)}
      aria-label="copy password">
      <span>
        <Icon className="icon-copy4" />
      </span>
    </Button>
  </InputGroup>;
};

export default React.memo(MailClientPasswordComponent);